import firebase from 'firebase'
import SystemConstants from '@app/constants/SystemConstants'
import urls from '@app/plugins/urls'
import { accountModule, authModule } from '@app/store'
import { isAuth } from '@app/utils/auth'
export default async function ({
  app,
  store,
  route,
  redirect,
}: {
  app: any
  store: any
  route: any
  redirect: any
}) {
  console.log(`[middleware] auth`)
  // Storeが持っている認証状態を確認
  const isAuthenticated = await isAuth()

  if (isAuthenticated) {
    try {
      const user = await accountModule.getUser(true)
      redirect(urls.mypage)
    } catch (e) {
      console.log(`[Log] display page`)
    }
  } else {
    redirect(urls.login)
  }
}
